import * as React from 'react';
import { useSelector } from 'react-redux';
import * as _ from 'lodash';

import { ticketContactDataSelector } from '@/redux/app/selectors/ticket';

import { TicketStatusSelector } from '../../ticket/TicketStatusSelector';
import { TicketUnaddressedToggle } from '../../ticket/TicketUnaddressedToggle';

export const TicketCardHeader = ({ ticket }: { ticket: string }) => {
  const contact = useSelector(_.partial(ticketContactDataSelector, ticket));
  return (
    <div className="ticket-header">
      <TicketUnaddressedToggle ticket={ticket} />
      <div className="ticket-header-text-container">
        <h4 className="display-name">
          {contact?.identifier ?? ''}
        </h4>
        <h5 className="display-company">
          {_.truncate(contact?.company, { length: 55, omission: '...' })}
        </h5>
      </div>
      <TicketStatusSelector ticket={ticket} selectorClassName="ticket-view" />
    </div>
  );
};
